import { countryCode, language } from '../services/translator';

export const MAX_RESULT = 100;
export const POS_ZOOM_LEVEL = 14;
export const POS_SELECTED_ZOOM_LEVEL = 17;
export const POS_MAX_ZOOM_LEVEL = 18; // Google map max zoom level
export const POS_SHOP_QUERY_PARAMETER = 'pos';
export const POS_FILTERS_QUERY_PARAMETER = 'filters';
export const POS_SEARCH_QUERY_PARAMETER = 'search';
export const POS_ANNOUNCEMENT_COOKIE = 'announcement';
export const POS_ANNOUNCEMENT_COOKIE_EXPIRATION = 365;
export const POS_COUNTRY_COOKIE = 'countryCode';
export const POS_POSITION_LAT_DELTA = 0.00006;
export const POS_POSITION_LNG_DELTA = 0.00006;
export const POS_REQUEST_MAX_ITEMS = 20;

export const POS_POSITION_URLS = {
  development: countryCode => `/fixtures/${countryCode === 'CN' ? 'posB' : 'posG'}.json`,
  test: countryCode => `/fixtures/${countryCode === 'CN' ? 'posB' : 'posG'}.json`,
  preProduction : countryCode => `/store/json/${countryCode === 'CN' ? 'posB' : 'posG'}.json`,
  production : countryCode => `/store/json/${countryCode === 'CN' ? 'posB' : 'posG'}.json`
};

export const POS_FILTERS_URLS = {
  development: '/fixtures/filters.json',
  test: '/fixtures/filters.json',
  preProduction : '/store/json/filters.json',
  production : '/store/json/filters.json'
};

export const POS_SEARCH_URLS = {
  development: (ids) => `https://tpc33of0na.execute-api.eu-west-1.amazonaws.com/beta/PointOfSale?ids=${ids}`,
  test: (ids) => `/fixtures/pos_list.json?ids=${ids}`,
  preProduction: (ids) => `https://tpc33of0na.execute-api.eu-west-1.amazonaws.com/beta/PointOfSale?ids=${ids}`,
  production: (ids) => `https://tpc33of0na.execute-api.eu-west-1.amazonaws.com/prod/PointOfSale?ids=${ids}`
};

export const POS_ANNOUNCEMENT_URLS = {
  development: (locale) => `https://tpc33of0na.execute-api.eu-west-1.amazonaws.com/beta/GetAnnouncement?countryCode=${locale}`,
  test: (locale) => `/fixtures/announcement.json`,
  preProduction: (locale) => `https://tpc33of0na.execute-api.eu-west-1.amazonaws.com/beta/GetAnnouncement?countryCode=${locale}`,
  production: (locale) => `https://tpc33of0na.execute-api.eu-west-1.amazonaws.com/prod/GetAnnouncement?countryCode=${locale}`
};

export const POS_CLIENT_ID_GMAP = 'gme-louisvuittonmalletier';
export const POS_KEY_GMAP = 'AIzaSyBxDzO7ADpPop3Eui_h7WBzLWQMMqpP3p8';
export const POS_SCRIPT_GMAP = (channel) => {
  if (countryCode === 'TW') {
    return `https://maps.googleapis.com/maps/api/js?libraries=places&client=${POS_CLIENT_ID_GMAP}&channel=${channel}&language=zh-TW&key=${POS_KEY_GMAP}`;
  }
  return `https://maps.googleapis.com/maps/api/js?libraries=places&client=${POS_CLIENT_ID_GMAP}&channel=${channel}&language=${language}&key=${POS_KEY_GMAP}`;
};
export const POS_KEY_BMAP = '15g5wWZdyYTxcIWsZDuz4mVYMDdVlzDM';
export const POS_SCRIPT_BMAP = () => `https://api.map.baidu.com/getscript?v=2.0&ak=${POS_KEY_BMAP}`;



// WEBPACK FOOTER //
// ./src/settings/pointOfSale.js